import template from './am-group-list.component.html';
import { Paging } from '../../core/models/am-helper.model';
import Auth from '../../../../auth';
class AmGroupListComponent {
  constructor(amGroupsService, amFilterPaginationService, $state) {
    'ngInject';
    this.groups = [];
    this.group = {};
    this.filteredGroups = [];
    this.status = '';
    this.createGroupStatus = '';
    this.$state = $state;
    this.filterPaginationService = amFilterPaginationService;
    this.groupService = amGroupsService;
    this.paging = new Paging(7, 1);
    this.filter = {
      query: '',
      orderBy: 'name',
      desc: false,
    };
    this.propertyKeys = ['name'];
    this.email = '';
    this.addToDataLayer = (data) => window.dataLayer.push(data);
  }
  $onInit() {
    this.getClaims();
    this.getGroups();
  }
  $onChanges() {}

  $onDestroy() {}

  getClaims() {
    const claims = Auth.getClaims();
    this.email = claims.email;
  }

  getGroups() {
    this.status = 'loading';
    this.groupService
      .retrieveGroups()
      .then((groups) => {
        this.groups = groups || [];
        this.status = this.groups.length ? '' : 'no-data';
        this.getGroupsPaged();
      })
      .catch(() => {
        this.status = 'error';
      });
  }

  onTriggerSearch(term) {
    this.filter.query = term;
    this.filteredGroups = this.filterPaginationService.filterByTerm(
      this.groups,
      this.filter.query,
      this.propertyKeys,
    );
    this.paging.reset();

    if (term !== '') {
      this.addToDataLayer({
        event: 'accessManagementGroupSearching',
        data: {
          keyword: term,
        },
      });
    }
  }

  loadPage(pageNumber) {
    this.paging.currentPage = pageNumber;
    this.getGroupsPaged();
  }

  getGroupsPaged() {
    this.filterPaginationService
      .getPaged(this.filter, this.paging, this.groups, this.propertyKeys)
      .then((result) => {
        this.filteredGroups = result.data;
      })
      .catch(() => {});
  }

  viewGroupDetail(group) {
    if (group) {
      this.$state.go('access-management.group-view', {
        id: group.id,
        name: group.name,
      });
    }
  }
  createGroup() {
    if (!this.group.name || !this.group.email) return;
    this.saveGroup();
  }

  saveGroup() {
    this.createGroupStatus = 'creating';
    // Call the service
    this.groupService
      .createGroup(this.group)
      .then((created) => {
        this.createGroupStatus = 'success';
        this.viewGroupDetail(created);
      })
      .catch((error) => {
        this.createGroupStatus = 'error';
        if (this.group.email === this.email) {
          this.createGroupStatusCode = 'invalid-email';
          return;
        }
        this.createGroupStatusCode = error.status;
      });
  }
}

export default {
  template,
  controller: AmGroupListComponent,
  controllerAs: 'groupListVm',
  bindings: {},
};
